import React from "react";
import {useTranslation} from "react-i18next";
import {IonItem, IonLabel, IonList} from "@ionic/react"

import TimeLimit    from "../../types/TimeLimit"
import KeyTimeLimit from "@customTypes/KeyTimeLimit"

import IconKeyInUse             from "../common/Icons/KeyInUse"
import BadgeKeyProgrammingState from "../common/Badges/BadgeKeyProgrammingState"
import ItemSegmentListHeader    from "../common/Headers/ItemSegmentListHeader"

interface componentProps {
    item: TimeLimit | undefined;
}

const List: React.FC<componentProps> = ({ item }) => {

    const {t} = useTranslation()

    const title: string    = item?.name || ''
    const subTitle: string = item?.description ? item?.description : ''

    return (
        <IonList lines="full">
            <ItemSegmentListHeader title={title} subTitle={subTitle} />

            {item === undefined || item.keyTimeLimits?.length === 0 ? (
                <IonItem className="ion-text-center">
                    <IonLabel className="ion-text-wrap">
                        {t('time-limits.no_keys_for_time_limit')}
                    </IonLabel>
                </IonItem>
            ) : (
                item.keyTimeLimits?.map( (keyTimeLimit: KeyTimeLimit) => {
                    if (! keyTimeLimit.key) {
                        return
                    }

                    return (
                        <IonItem button detail key={'key-' + keyTimeLimit.key.id} lines="inset"
                                 routerLink={'/keys-in-use/' + keyTimeLimit.key.id + '/view'}>
                            <IconKeyInUse icon={keyTimeLimit.key?.keyType?.icon} slot="start" />
                            <IonLabel>
                                <h2>{keyTimeLimit.key.description}</h2>
                                <p style={{ 'textTransform': 'uppercase' }}>
                                    {keyTimeLimit.key.keyType?.name}
                                </p>
                            </IonLabel>
                            {keyTimeLimit.key.keyProgrammingState &&
                                <BadgeKeyProgrammingState item={keyTimeLimit.key.keyProgrammingState} />
                            }
                        </IonItem>
                    )
                })
            )}
        </IonList>
    )
}

export default List